const FULL_HEIGHT_NO_INPUT_ROW = '40%'
const FULL_HEIGHT_ONE_INPUT_ROW = '30%'
const FULL_HEIGHT_TWO_INPUT_ROW = '30%'

const EnableAllSeries = (series) => {
    if (!series) return series
    for (let i = 0; i < series.length; i++) {
        series[i].visible = true
    }
    return series
}

const DisableSeriesWithNoData = (series) => {
    if (!series) return series
    for (let i = 0; i < series.length; i++) {
        let ser = series[i]
        if (!ser.data || ser.data.length === 0) {
            ser.visible = false
        }
    }
    return series
}

const DisableCatSeries = (series) => {
    if (!series) return series
    for (let i = 0; i < series.length; i++) {
        let ser = series[i]
        let name = ser.name
        if (name && name.substring(name.length - 3, name.length) === 'CAT') {
            ser.visible = false
        }
    }
    return series
}

const DisableAllButFirstSeries = (series) => {
    if (!series) return series
    for (let i = 0; i < series.length; i++) {
        if (i > 0) {
            series[i].visible = false
        }
    }
    return series
}

const DisableAllButISeries = (series, index) => {
    if (!series) return series
    for (let i = 0; i < series.length; i++) {
        if (i !== index) {
            series[i].visible = false
        }
    }
    return series
}

const DisableFirstSeries = (series) => {
    if (!series) return series
    if (series.length > 0) {
        series[0].visible = false
    }
    return series
}

const DisableSeriesDataLabels = (series) => {
    if (!series) return series
    for (let i = 0; i < series.length; i++) {
        series[i].dataLabels = { enabled: false }
    }
    return series
}

const CurrencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
})

const SetupDefaultOptions = (opts, height, fetching, yAxisTitle) => {
    opts = opts || {}
    opts.chart = opts.chart || {}
    // we should be managing height thru parent container
    //opts.chart.height = height

    opts.chart.chartState = {
        ...opts.aggregateData,
        fetching: fetching,
    }

    opts.tooltip = {
        formatter: function () {
            const {
                series: {
                    userOptions: { name, xName },
                },
            } = this
            return xName
                ? this.x +
                      '<br/><b>' +
                      name +
                      '</b>: <b>' +
                      CurrencyFormatter.format(this.y || 0) +
                      '</b>'
                : '<b>' + name + '</b>: <b>' + CurrencyFormatter.format(this.y || 0) + '</b>'
        },
    }

    opts.plotOptions = {
        column: {
            dataLabels: {
                // formatter: function () {
                //     console.dir(this)
                //     return CurrencyFormatter.format(this.point.y || 0)
                // },
                format: '${point.y:,.0f}',
                allowOverlap: true,
            },
        },
    }

    yAxisTitle = yAxisTitle || ''
    opts.yAxis = {
        title: {
            text: yAxisTitle,
        },
        labels: {
            format: '${value:,.0f}',
        },
    }

    return opts
}

export {
    EnableAllSeries,
    DisableSeriesWithNoData,
    SetupDefaultOptions,
    DisableFirstSeries,
    DisableAllButFirstSeries,
    DisableAllButISeries,
    DisableSeriesDataLabels,
    DisableCatSeries,
    CurrencyFormatter,
    FULL_HEIGHT_NO_INPUT_ROW,
    FULL_HEIGHT_ONE_INPUT_ROW,
    FULL_HEIGHT_TWO_INPUT_ROW,
}
